import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C2E0FF",
      d: "M13 0c1.688 0 3.188.984 3.938 2.438 1.546-.516 3.28-.141 4.546 1.078 1.22 1.218 1.547 3 1.078 4.547C24.017 8.813 25 10.313 25 12a4.48 4.48 0 0 1-2.437 3.984 4.38 4.38 0 0 1-1.079 4.5c-1.265 1.22-3 1.594-4.547 1.125A4.42 4.42 0 0 1 13 24c-1.734 0-3.234-.937-3.984-2.39-1.547.468-3.282.093-4.547-1.126-1.219-1.218-1.547-2.953-1.078-4.5C1.938 15.234 1 13.734 1 12c0-1.687.938-3.187 2.39-3.937A4.46 4.46 0 0 1 4.47 3.516c1.265-1.22 3-1.594 4.547-1.078A4.48 4.48 0 0 1 13 0m-3 10.5c.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5m6 3c-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5m.75-3.703c.469-.422.469-1.125 0-1.594a1.104 1.104 0 0 0-1.547 0l-6 6c-.469.469-.469 1.172 0 1.594a1.027 1.027 0 0 0 1.547 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F85FA",
      d: "M11.5 9c0 .844-.703 1.5-1.5 1.5A1.48 1.48 0 0 1 8.5 9c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5m6 6c0 .844-.703 1.5-1.5 1.5a1.48 1.48 0 0 1-1.5-1.5c0-.797.656-1.5 1.5-1.5.797 0 1.5.703 1.5 1.5m-6.75.797a1.027 1.027 0 0 1-1.547 0c-.469-.422-.469-1.125 0-1.594l6-6a1.104 1.104 0 0 1 1.547 0c.469.469.469 1.172 0 1.594z"
    }, null, -1)
  ]))]))
}
export default { render: render }